<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  assistencia: {
    type: Object,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:open', 'rejeitar', 'cancelar']);

const motivo = ref('');
const motivoError = ref('');

const validateForm = () => {
  motivoError.value = '';
  
  if (!motivo.value.trim()) {
    motivoError.value = 'Por favor, informe o motivo da rejeição.';
    return false;
  }
  
  return true;
};

const handleRejeitar = () => {
  if (validateForm()) {
    emit('rejeitar', props.assistencia, motivo.value);
  }
};

const handleCancel = () => {
  emit('cancelar');
  emit('update:open', false);
};

// Reset form when modal opens
watch(() => props.open, (newValue) => {
  if (newValue) {
    motivo.value = '';
    motivoError.value = '';
  }
});
</script>

<template>
  <v-dialog
    :model-value="open"
    @update:model-value="$emit('update:open', $event)"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5 bg-error text-white">
        <v-icon start icon="mdi-close-circle" class="mr-2"></v-icon>
        Rejeitar Assistência Técnica
      </v-card-title>
      
      <v-card-text class="pt-4 pb-0">
        <p class="text-body-1 mb-4">
          Você está rejeitando a assistência técnica #<strong>{{ assistencia?.id }}</strong>.
          Por favor, informe o motivo da rejeição:
        </p>
        
        <v-textarea
          v-model="motivo"
          label="Motivo da rejeição"
          rows="3"
          :error-messages="motivoError"
          :disabled="loading"
          variant="outlined"
          placeholder="Informe o motivo da rejeição da assistência técnica"
          class="mb-4"
          hide-details="auto"
        ></v-textarea>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn 
          color="grey-darken-1" 
          variant="text" 
          @click="handleCancel"
          :disabled="loading"
        >
          Cancelar
        </v-btn>
        <v-btn 
          color="error" 
          @click="handleRejeitar"
          :loading="loading"
          :disabled="loading"
        >
          Rejeitar Assistência
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
